import { Building, InitHandlerPayload, Theme } from '@hqo/hqo-miniapp-client-sdk';
import { useMiniappSdkEventHandler } from 'app/shared/hooks/use-miniapp-sdk';
import { User } from 'app/data/types/user';
import { useState } from 'react';

interface SdkData {
  sdkUser?: User | null;
  sdkBuilding?: Building | null;
  sdkTheme?: Theme | null;
  availableCmds: string[];
}

export const useSdkData = (): SdkData => {
  const [sdkUser, setSdkUser] = useState<User | null>(null);
  const [sdkBuilding, setSdkBuilding] = useState<Building | null>(null);
  const [sdkTheme, setSdkTheme] = useState<Theme | null>(null);
  const [availableCmds, setAvailableCmds] = useState<string[]>([]);

  useMiniappSdkEventHandler(
    'initResponse',
    (eventData) => {
      const data = eventData as InitHandlerPayload;

      if (data?.user) {
        setSdkUser(data.user);
      }
      if (data?.building) {
        setSdkBuilding(data.building);
      }
      if (data?.theme) {
        setSdkTheme(data.theme);
      }
      if (data?.available_cmds) {
        setAvailableCmds(data.available_cmds);
      }
    },
    [],
  );

  return { sdkUser, sdkBuilding, sdkTheme, availableCmds };
};
